import React from 'react'
import NavLink from '../Routes/NavLink'

import BuildingTemplateCard from '../Building/BuildingTemplateCard'

export default class BuildingTemplatesGUI extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        const buildingTemplates = this.props.data;
        const activateTemplate = this.props.activateTemplate;
        const activeTemplateID = this.props.templateID;
        return (
            <div class="row">
                {buildingTemplates != null && buildingTemplates.length > 0 && (
                    buildingTemplates.map(function(buildingTemplate, index){
                        const templateSpecs = buildingTemplate.building_template_data.template_specs;
                        const templateID = buildingTemplate.building_template_id;
                        const templateName = buildingTemplate.building_template_name;
                        const levelLimit = buildingTemplate.building_template_floor_limit;
                        return (
                            <BuildingTemplateCard key={templateID} name={templateName} specs={templateSpecs} levelLimit={levelLimit} activeTemplateID={activeTemplateID} templateID={templateID} activateTemplate={activateTemplate}/>
                        )
                    })
                )}
                <BuildingTemplateCard activeTemplateID={activeTemplateID} activateTemplate={activateTemplate} templateID={0}/>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Buildings/BuildingTemplatesGUI.jsx